import $ from 'jquery';
import 'select2';                       // globally assign select2 fn to $ element
import 'select2/dist/css/select2.css';  // optional if you have css loader

// $(() => {
//     $('.select2').select2({
//         width: 'resolve'
//     });
//     $('.select2').on('select2:select', function (e) {
//         var data = e.params.data;
//         $('')
//         Livewire.emit('select2Change', data);
//     });
// });

window.addSelect2 = function(entity, id, value){
    var $el = $('#'+entity+'-'+ id);
    if (!$el.length) {
        return;
    }
    // El repeater vuelve a llamar aqui para todas las filas despues de cada seleccion.
    // Sin destruir la instancia previa y sin soltar el handler, cada pasada acumulaba
    // un select2 huerfano y un listener mas, multiplicando los emits por fila.
    if ($el.data('select2')) {
        $el.select2('destroy');
    }
    $el.off('select2:select');
    $el.select2({
        // width: 'resolve',
        // allowClear: true
    });
    $el.val(value).trigger('change');
    $el.on('select2:select', function (e) {
        var data = e.params.data;
        Livewire.emit('select2Change', {data, id, entity});
    });
}

window.addMultipleSelect2 = function(entity, id, values){
    $('#'+entity+'-'+ id).select2({
        width: 'resolve',
        multiple: true,
    });
    $('#'+entity+'-'+ id).val(values).trigger('change');
    $('#'+entity+'-'+ id).on('select2:select', function (e) {
        var data = e.params.data;
        Livewire.emit('MultipleSelect2Select', {data, id, entity});
    });
    $('#'+entity+'-'+ id).on('select2:unselect', function (e) {
        var data = e.params.data;
        Livewire.emit('MultipleSelect2Unselect', {data, id, entity});
    });
}
